<form [formGroup]="formGroup">
  <div>
    <div nz-row [nzGutter]="[16, 16]">
      <div nz-col nzSpan="24">
        <app-control formControlName="card_no" [controlConfig]="{title: 'card.code', type: 'text'}"></app-control>
      </div>
      <div nz-col nzSpan="24">
        <app-control formControlName="owner" [controlConfig]="{title: 'service-card.owner', type: 'text'}"></app-control>
      </div>
      <div nz-col nzSpan="24">
        <app-control formControlName="old_apartment_ids"
          [controlConfig]="{title: 'service-card.old_apartment', type: 'text'}"></app-control>
      </div>
      <div nz-col nzSpan="24">
        <app-control formControlName="new_apartment_ids" [options]="listApartment" [customErrorText]="errorApartment"
          [controlConfig]="{title: 'service-card.new_apartment', type: 'multi-select', required: true}"></app-control>
      </div>
      <div nz-col nzSpan="24">
        <app-control formControlName="note" [controlConfig]="{title: 'note', type: 'textarea'}"></app-control>
      </div>
    </div>
  </div>
</form>

<div *nzModalTitle class="title-modal">{{'service-card.update-card' | translate}}</div>
<div *nzModalFooter>
  <button nz-button class="btn-cancel-modal" (click)="destroyModal()">{{'close' | translate}}</button>
  <button nz-button nzType="primary" (click)="onSave()">{{'save' | translate}}</button>
</div>